import * as v from 'valibot';

import { ENOPOrganType } from '#shared';

import type { Organ } from '../types';

export const organSchema: v.GenericSchema<Organ> = v.object({
  id: v.string('Organ ID is missing'),
  name: v.enum(
    ENOPOrganType,
    issue => `@WARNING: Unexpected organ type ${issue.input}`,
  ),
  startPoint: v.number('Organ start point is missing'),
});

export const ENOPOrganTypeSchema = v.enum(ENOPOrganType, 'ENOPOrganTypeSchema');
